export default __webpack_public_path__ + "static/media/coin-stack.5c5aaa82.png";